var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDiversity2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 49.7291C16.0183 49.7291 6.27075 39.9816 6.27075 27.9999C6.27075 16.0183 16.0183 6.27075 27.9999 6.27075C39.9816 6.27075 49.7291 16.0183 49.7291 27.9999C49.7291 39.9816 39.9816 49.7291 27.9999 49.7291ZM27.9999 10.0624C18.1095 10.0624 10.0624 18.1095 10.0624 27.9999C10.0624 37.8903 18.1095 45.9374 27.9999 45.9374C37.8903 45.9374 45.9374 37.8903 45.9374 27.9999C45.9374 18.1095 37.8903 10.0624 27.9999 10.0624Z",
    fill: "#94C6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7083 35.5833H37.0417C36.3973 35.5833 35.875 36.1056 35.875 36.7499V48.4166C35.875 49.0609 36.3973 49.5833 37.0417 49.5833H48.7083C49.3527 49.5833 49.875 49.0609 49.875 48.4166V36.7499C49.875 36.1056 49.3527 35.5833 48.7083 35.5833Z",
    fill: "#7666EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5909 35.3424L6.17481 41.7585C5.7192 42.2141 5.7192 42.9528 6.17481 43.4085L12.5909 49.8246C13.0465 50.2802 13.7852 50.2802 14.2408 49.8246L20.6569 43.4085C21.1126 42.9528 21.1126 42.2141 20.6569 41.7585L14.2408 35.3424C13.7852 34.8868 13.0465 34.8868 12.5909 35.3424Z",
    fill: "#15C480"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4166 19.8333C17.2826 19.8333 20.4166 16.6992 20.4166 12.8333C20.4166 8.96726 17.2826 5.83325 13.4166 5.83325C9.55063 5.83325 6.41663 8.96726 6.41663 12.8333C6.41663 16.6992 9.55063 19.8333 13.4166 19.8333Z",
    fill: "#FFC82A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8658 6.94734L35.7437 17.5523C35.2946 18.3311 35.8546 19.3023 36.7529 19.3023H49C49.8983 19.3023 50.4583 18.3311 50.0092 17.5523L43.8871 6.94734C43.4379 6.16859 42.315 6.16859 41.8658 6.94734Z",
    fill: "#F0464F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0057 27.1249C30.2609 27.1249 32.089 25.2967 32.089 23.0416C32.089 20.7864 30.2609 18.9583 28.0057 18.9583C25.7505 18.9583 23.9224 20.7864 23.9224 23.0416C23.9224 25.2967 25.7505 27.1249 28.0057 27.1249Z",
    fill: "#3987F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.037 35.875C30.1845 35.875 25.8182 35.875 22.9657 35.875C21.2653 35.875 20.1249 34.1105 20.8424 32.5675C22.0878 29.8959 24.8237 28.1721 27.9999 28.1721C31.1762 28.1721 33.9149 29.8988 35.1574 32.5675C35.8749 34.1075 34.7345 35.875 33.0341 35.875H33.037Z",
    fill: "#3987F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiversity2);
export default __webpack_public_path__ + "static/media/icon_diversity_2.7381ccd9.svg";
export { ForwardRef as ReactComponent };